// plugins/varify.client.js

export default defineNuxtPlugin((nuxtApp) => {
  // Access the public runtime config
  const config = useRuntimeConfig()

  if (process.client && config.public.varifyId) {
    // Initialize the varify object with your account ID
    window.varify = window.varify || {}
    window.varify.iid = config.public.varifyId

    // Create and append the Varify.io script
    const script = document.createElement('script')
    script.src = 'https://app.varify.io/varify.js'
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  } else {
    console.warn('Varify.io ID is not set in the runtime configuration.')
  }
})
